export default __webpack_public_path__ + "static/media/workTicket.svg";